var dropdownGroup = 'group_dropdownGroup__pal1wu0';

export { dropdownGroup };
//# sourceMappingURL=group.vanilla.mjs.map
